import {and, not, or} from '@/model/helpers/conditions/utils';
import {isNewContract, isOperation} from '@/model/helpers/section-a';
import {
  hasLoanOrExternalFundTransfer,
  hasNoPayrollDeductionOrExternalTransferOrAccountFunding,
} from '@/model/helpers/section-i';
import {Operations} from '@/model/src/values/dv-48';
import {Condition} from '@/model/types';

export const isModifyPeriodic = isOperation(Operations.MODIFY_OR_TERMINATE_PERIODIC_DEPOSIT);

export const isDPAOnlyDeposit = and(
  isOperation(Operations.DEPOSIT),
  not(hasLoanOrExternalFundTransfer),
) satisfies Condition;

export const isDPAOnlyOrModifyPeriodic = or(isModifyPeriodic, isDPAOnlyDeposit) satisfies Condition;

export const isInternallyFundedDepositOrNewContract = and(
  or(isOperation(Operations.DEPOSIT), isNewContract),
  hasNoPayrollDeductionOrExternalTransferOrAccountFunding,
) satisfies Condition;
